// @flow
import React, { PureComponent } from 'react';

type Props = {
};

export default class NotFound extends PureComponent<void, Props, void> {
  render() {
    return (
      <h1>Not found</h1>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/index/not-found/view.js
 **/